export default __webpack_public_path__ + "static/media/icon-divider.d67a719e.svg";